import { Toast } from 'mint-ui';
import YunJi from '@/common/js/YunJi.js';

export const ERR_CODE = 0;//0代表请求成功的code

export const FAIL_CODE = "2419"; //2419代表请求用户未验证通过
export let toastInstance = null;

export function toastShow(tip,icon,duration){
  //如果toast提示展示，等toast消失才能继续响应事件，防止重复点击
  if(toastInstance != null){
    toastInstance.close();
  }
  let iconClass = ""; //图标样式
  switch (icon) {
    case "success":
      iconClass = "iconfont icon-gouhao";
      break;
    case "warn":
      iconClass = "iconfont icon-gantanhao";
      break;
    default :
      iconClass = "";
      break;
  }
  toastInstance = Toast({
    message: tip,
    iconClass: iconClass,
    duration: duration || 2000
  });
}

/**
 * 当用户cookie错误或者失效，重新设置用户cookie信息，只有微信版才有该功能
 */
export function setCookiesAndSetCookies(){
  //重新用户cookie
  let returnUrl = window.location.href;
  //<--脚本替换链接带#号逻辑(修改需联系欢歌)
  returnUrl = returnUrl.substring(returnUrl.indexOf("yjbuyer/")+8,returnUrl.length);
  getUserCookies(returnUrl);
}

/**
 * 获取用户cookie信息，只有微信版才有该功能
 */
export function getUserCookies(returnUrl){
  if (YunJi.getUrlParams('getUserCookiesMarkFlag') == '') {
    let appCont = YunJi.getUrlParams('appCont') || 0;
    // 解决不带任何参数的链接重写向后全部回到首页问题
    if(!returnUrl.match('[\?]')){
      returnUrl = returnUrl+"?appCont="+appCont;
    }
    // 判断是否是首次授权，cookie存在表示不是，不是则走原流程，cookie不存在表示是，是则走中间页流程
    let jumpUrl = "//"+globalConfig.linkBasePath+"/yunjibuyer/getVueUser.xhtml?returnUrl="+encodeURIComponent(returnUrl + '&getUserCookiesMarkFlag=true');
    // if(YunJi.getCookie('YUNJI_WEChAT_AYTHOTIZED')){
    //   window.location.href = jumpUrl
    // } else {
    //   window.location.href = "//"+globalConfig.linkBasePath+"/basecomponents/weChatAuthorized.html?returnUrl="+encodeURIComponent(jumpUrl) + "&titleName=云集";
    // }
    try {
      var modal = new Modal({
        title: '云集',
        returnUrl: jumpUrl
      })
    } catch (error) {
      window.location.href = jumpUrl
    }
  }
}
/**
 * 路由增加正则匹配
 * @param {Array} routes 
 * @param {Object} opt ->  
 * include: 只有匹配path路由的才会添加正则,  
 * exclude: 任何匹配path路由的都不会增加正则
 */
export function eachRouter(routes, opt={
  include: [],
  exclude: []}
) {
  routes.forEach(key => {
    if (opt.include.length && opt.exclude.length) {
      throw new Error('不能同时传入include和exclude')
    }
    if (key.path === '*' || key.path.indexOf(':') > -1 || key.path === '/') return
    if (opt.include.length && opt.include.indexOf(key.path) === -1) return
    if (opt.exclude.length && opt.exclude.indexOf(key.path) > -1) return
    if (key.children && key.children.length) {
      eachRouter(key.children, opt) 
      return
    }
    
    key.path += ':v(_?v?\\d*)'
  })
}

export function isWxProgram() {
  return navigator.userAgent.indexOf('miniprogram') > -1 || window.__wxjs_environment === 'miniprogram'
}

function isInViewPortOfTwo (el) {
  const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight 
  const top = el.getBoundingClientRect() && el.getBoundingClientRect().top
  console.log('top', top)
  return top  <= viewPortHeight + 100
}

//生成uuid
export function uuid () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

export function isElementInViewport(el) {
  //获取元素是否在可视区域
  var rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function exposureThinkingReport () {
  let listArr = document.getElementsByClassName('GOODITEM')
  let idArr = []
  if (listArr && listArr.length) {
    for (let i = 0; i < listArr.length; i++) { 
      let inView = isElementInViewport(listArr[i])
      if (inView) {
        idArr.push(listArr[i].getAttribute('data-id'))
      }
    }
  }
  return idArr
}
// 开始的值 结束的值 回调函数 滚动间隔
// callback用来设置变动的值
export function rollingNumber(options, callback) {
  const defaultOptions = { rollingTime: 500, interval: 10 }
  options = Object.assign({}, defaultOptions, options)

  let timer1 = null // 计时器
  let startValue = Number(options.start) // 起始值
  let endValue = Number(options.end) // 结束值

  const speed = (endValue - startValue) / (options.rollingTime / options.interval)
  console.log('speed', speed)

    // 奖金动画
  const initAwardTimer = () => {
    // 没有结束值就结束
    if (endValue === '') {
      return
    }
    // 清空当前计时器 防止重复
    clearInterval(timer1)
    const target = endValue
    const difference = target - (startValue || 0)
    // Math.abs(difference) / 50 < 1 ? 1 : Math.ceil(Math.abs(difference) / 50)
    // 没有差值的话就结束
    if (difference === 0) {
      endValue = ''
      initAwardTimer()
      return
    }
    timer1 = setInterval(() => {
      // 不足下一次跳跃
      if ((difference > 0 && startValue >= target - speed) || (difference < 0 && startValue - speed <= target)) {
        clearInterval(timer1)
        startValue = target
        endValue = ''
        callback(startValue)
        initAwardTimer()
      } else {
        // 差值为正就+ 否则-
        startValue = startValue + (difference > 0 ? speed : -speed)
        callback(startValue)
      }
    }, options.interval)
  }
  initAwardTimer()
}